<template>
	<div class="relative">
		<div class="fixed white" style="width: 100%;" id="tool-bar">
			<v-row style="width: 100%" align="center" justify="start" class="ma-0">
				<v-col cols="auto" sm="6" xs="6" md="12" lg="auto">
					<slot name="breadcrumbs"></slot>
				</v-col>
			</v-row>
			<v-layout wrap class="d-flex flex-row my-border rounded-lg mx-3 mb-3 align-center">
				<v-col lg="2" sm="auto" cols="12" class="d-flex flex-column">
					<bee-autocomplete
						:label="$t('JournalsPage.type')"
						:items="typeList"
						item-text="name"
						item-value="id"
                        v-model="type"
						@keydown-enter-prevent="search()"
						:hide-details="true"
						context="bond"
                        @change="onTypeChange()"
						:action-name="actions.GET"
					></bee-autocomplete>
				</v-col>
				<v-col lg="2" sm="auto" cols="12" class="d-flex flex-column">
					<bee-autocomplete
                        :disabled="!(type === 0 || type == 1)"
						:label="$t('JournalsPage.bond-no')"
						:items="type == 1 ? simplified_accounting_bonds : simplified_cash_bonds"
                        v-model="bondId"
						item-text="bond_no"
						item-value="id"
						@keydown-enter-prevent="search()"
						:hide-details="true"
						context="bond"
						:action-name="actions.GET"
					></bee-autocomplete>
				</v-col>
                <v-col sm="auto" cols="12" class="pl-lg-0 d-flex flex-column">	
                    <bee-date-picker
                        context="bond" 
                        :action-name="actions.GET" 
						:label="$t('JournalsPage.start-date')"
                        v-model="fromDate"
                        :hide-details="true"
                        @keydown-enter-prevent="search()"
                    ></bee-date-picker>
                </v-col>
				<v-col sm="auto" cols="12" class="pl-lg-0 d-flex flex-column">	
                    <bee-date-picker
                        context="bond" 
                        :action-name="actions.GET" 
						:label="$t('JournalsPage.end-date')"
                        v-model="toDate"
                        :hide-details="true"
                        @keydown-enter-prevent="search()"
                    ></bee-date-picker>
                </v-col>
				<v-col sm="auto" cols="12" lg="2" class="pl-lg-0 d-flex flex-column">
					<bee-autocomplete
						:label="$t('JournalsPage.bond-status')"
						:items="statusList"
						item-text="name"
						item-value="id"
                        v-model="status"
						@keydown-enter-prevent="search()"
						:hide-details="true"
						context="bond"
                        @change="onTypeChange()"
						:action-name="actions.GET"
					></bee-autocomplete>
				</v-col>
				<v-spacer></v-spacer>
				<v-col sm="auto" cols="12" class="d-flex">
					<bee-btn
						@click="search()"
						:content="$t('JournalsPage.refresh')"
						color="blueGray"
						outer-class="me-3"
						:loading="loading"
						context="bond"
						:action-name="actions.GET"
					></bee-btn>
                    <v-icon small color="grey" @click="reset(); search()" :loading="loading">fa-times-circle</v-icon>
				</v-col>
			</v-layout>
		</div>
		<div class="ma-auto absolute" id="main" style="width: 100%; height: auto">
			<v-card flat>
				<v-card-text class="pt-0 px-3 mb-6">
					<bee-simple-table
						:with-color="false"
						:zebra="true"
						:hide-footer="true"
						empty-state="dashes"
						context="bond"
						:fixed-header="true"
						:action-name="actions.GET"
						:headers="headers"
						:items="simplified_bonds"
						:right-click-menu-items="right_click_menu_items"
						:configs="configs"
						:highlighted-expression="(item)=>{ return item.is_posted ? '' : '' }"
						:show-menu-actions="true"
						@reforward="reforward($event)"
                        @delete="deleteBond($event)">
                       
                        <template v-slot:[`item.is_posted`]="{ item }">
                            <v-chip :color="item.is_posted ? 'postedColor' : 'unpostedColor'" dark>
                                <span class="mx-1">
									{{
										item.is_posted
										? $t('JournalsPage.posted')
										: $t('JournalsPage.non-posted')
									}}
								</span>
                                <v-icon left dark small class="mx-1">{{ item.is_posted ? 'fa-envelope' : 'fa-envelope-open' }}</v-icon>
                            </v-chip>
                        </template>

                        <template v-slot:[`item.is_cash`]="{ item }">
                            <span class="mx-1">
								{{item.is_cash ? $t('JournalsPage.cash') : $t('JournalsPage.accounting')}}
							</span>
                        </template>

                    </bee-simple-table>
				</v-card-text>
			</v-card>
			<v-bottom-navigation app id="footer" class="px-3" horizontal background-color="greyLighten3">
				<v-row align="center" justify="center">
                    <bee-outlined-header-info
                    	:head="$t('JournalsPage.total-count')"
                    	empty-state="_"
                    	:content="configs? configs.num_of_total_bonds : null"
                    >
                    </bee-outlined-header-info>
                    <bee-outlined-header-info
                    	:head="$t('JournalsPage.non-posted-bonds-count')"
                    	content-color="red"
                    	empty-state="_"
                    	:content="configs? configs.num_of_not_posted_bonds : null"
                    >
                    </bee-outlined-header-info>
                </v-row>
			</v-bottom-navigation>
			<bee-dialog
				@close="close()"
                @handler="confirmDeleteBond()"
				confirm-button-color="red"
				v-model="deleteBondDialog"
				:title="$t('JournalsPage.delete-bond')"
				:message="
				$t('JournalsPage.do-you-want-to-delete-$-bond-with-no-$', {
					type: selectdRow.is_cash ? $t('JournalsPage.cash') : $t('JournalsPage.accounting'),
					no: selectdRow.bond_no
				})
				"
			></bee-dialog>
		</div>
	</div>
</template>
<script>
import store from "../../../store/index.js";
import { mapState } from "vuex";
import actions from "../../../permissions/actions-names.js";
import { bondType } from '@/helpers/enums.js';
export default {
	data: () => ({
		actions,
        status: null,
        type: null,
        loading: false,
        bondId: null,
        fromDate: null,
        toDate: null,
        deleteBondDialog: false, 
        selectdRow: { id: null, is_cash: null, bond_no: null },
		
		dateSortMode: [
			{ id: 0, name: null }, 
			{ id: 1, name:"Ascending" }, 
			{ id: 2, name:"Descending"}
		],
		bondTypeSortMode: [
			{ id: 0, name: null }, 
			{ id: 1, name:"AccountingFirst" }, 
			{ id: 2, name:"CashFirst"}
		]
	}),

	computed: {
		...mapState({
			simplified_bonds: state => state.bonds.filtered_simplified_bonds,
			simplified_cash_bonds: state => state.bonds.simplified_cash_bonds,
			simplified_accounting_bonds: state => state.bonds.simplified_accounting_bonds,
			configs: state => state.configs.configs,
		}),

		right_click_menu_items() {
			return [
				{
					name: 'reforward', 
					disabled: false, 
					text: this.$t('JournalsPage.right-click-menu-items.go-to-the-journal'), 
					action_name: actions.GET
				},
				{
					name: 'delete', 
					disabled: false, 
					text: this.$t('JournalsPage.right-click-menu-items.delete'), 
					action_name: actions.DELETE
				},
			]
		},
		typeList() {
			return [
				{ id: 0, name: this.$t('JournalsPage.cash') },
				{ id: 1, name: this.$t('JournalsPage.accounting') }
			]
		},
		statusList() {
			return [
				{ id: 0, name: this.$t('JournalsPage.all') },
				{ id: 1, name: this.$t('JournalsPage.posted') },
				{ id: 2, name: this.$t('JournalsPage.non-posted') }
			]
		},
		headers() {
			return [
                {
					text: this.$t('JournalsPage.headers.serial'),
					value: '',
					type: 'auto_increment',
					width: '5%', 
				},
				{
					text: this.$t('JournalsPage.headers.bond-no'),
					value: " bond_no",
					type: "string",
					width: "20%", 
				},
				{
					text: this.$t('JournalsPage.headers.type'),
					value: "is_cash",
					type: "",
					width: "25%", 
				},
				{
					text: this.$t('JournalsPage.headers.status'),
					value: "is_posted",
					type: "",
					width: "25%" 
				},
				{
					text: this.$t('JournalsPage.headers.date'),
					value: "date",
					type: "date",
					width: "25%", 
				},
			];
		},
		file_is_locked() {
			return this.configs?.financial_file?.is_locked;
		},
	},

	methods: {
		search() {
			store.dispatch("bonds/search", { bondId: this.bondId, type: this.type, status: this.status, fromDate: this.fromDate, toDate: this.toDate, dateSortMode: 2, bondTypeSortMode: 2 })
		},
		reset() {
			this.fromDate = new Date().toISOString().substr(0, 10),
			this.toDate = new Date().toISOString().substr(0, 10),
            this.status = 2,
            this.type = null,
            this.loading = false,
            this.bondId = null,
            this.close()
			if(this.configs)
				this.fromDate = this.configs.financial_file.start_date
		},
		reforward(row) {
			if (row.is_cash) 
                this.$router.push({ name: "cash-journal", params: { id: Number(row.id) } }).catch(()=>{})
            else 
                this.$router.push({ name: "accounting-journal", params: { id: Number(row.id) } }).catch(()=>{}) 
		},
        onTypeChange(){
            if(!this.type)
                this.bondId = null
        },
        deleteBond($event){
			this.selectdRow = {...$event}
            this.deleteBondDialog = true
        },
		confirmDeleteBond(){
			store.dispatch("bonds/delete", { bondId: this.selectdRow.id, bondType: this.selectdRow.is_cash ? bondType.cash : bondType.accounting })
			.then(() => {
				let promises = [ 
					store.dispatch("configs/fetchAll"),
					store.dispatch("bonds/search", { bondId: this.bondId, type: this.type, status: this.status, fromDate: this.fromDate, toDate: this.toDate, dateSortMode: 2, bondTypeSortMode: 2 }),
					store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }),
					store.dispatch("bonds/fetchAll", { bondType: bondType.cash })
				]
				Promise.all(promises)
			})
			.finally(() => this.close());	
        },
		close(){
			this.deleteBondDialog = false
			this.selectdRow =  { id: null, is_cash: null, bond_no: null }
		}
	},

	mounted() {
		this.reset()
		this.search()
		window.observer.observe(document.querySelector("#tool-bar"))
		window.observer.observe(document.querySelector("#footer"))
	},

	beforeDestroy() {
		this.reset()
	},

	async beforeRouteEnter(to, from, next) {
		let promises = []
		let object = store.state.configs.configs;
		if (Object.keys(object).length == 0)
			promises.push(store.dispatch("configs/fetchAll"));

		await Promise.all(promises);
		next();
	}
};
</script>
<style scoped>
.small {
	max-width: 600px;
	margin: 150px auto;
}
.small-font-size .v-label {
	font-size: 0.8rem !important;
	padding-right: 0px !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>